import { useSyncExternalStore } from 'react';
import type { FlagName } from '../store/types';
import { useFeatureFlagStore } from './FeatureFlagContext';

export function useFeatureFlagVariant(key: FlagName): string | undefined {
  const store = useFeatureFlagStore();

  return useSyncExternalStore(
    store.subscribe,
    () => {
      const value = store.getFlag(key);
      return typeof value === 'string' ? value : undefined;
    },
    () => undefined,
  );
}
